import { FormPart } from 'app/modules/shared/components/FormPart';
import { PhoneInputField } from 'app/shared/fields/PhoneInputField';
import { SelectDateField } from 'app/shared/fields/SelectDateField';
import { TextInputField } from 'app/shared/fields/TextInputField';

const prefix = 'assetInsurance';

export const InsuranceForm = () => {
  const formConfig = [
    {
      width: '100%',
      name: `${prefix}.company`,
      label: 'Company',
      component: TextInputField,
    },
    {
      width: '100%',
      name: `${prefix}.phoneNumber`,
      label: 'Phone #',
      component: PhoneInputField,
    },
    {
      width: '100%',
      name: `${prefix}.policyNumber`,
      label: 'Policy #',
      component: TextInputField,
    },
    {
      width: '100%',
      name: `${prefix}.effectiveDate`,
      label: 'Effective Date',
      component: SelectDateField,
    },
    {
      width: '100%',
      name: `${prefix}.expirationDate`,
      label: 'Expiry Date',
      component: SelectDateField,
    },
  ];

  return <FormPart name="Insurance" config={formConfig} marginTop={1} marginBottom={2} />;
};
